export const REFETCH_INTERVAL = 30000;
export const ANDROID_STORE_SPORTSBOOK_URL = 'https://fanduel.com/android';
export const APPLE_STORE_SPORTSBOOK_URL = 'https://apps.apple.com/us/app/fanduel-sportsbook-casino/id1413721906';
export default {};
